// import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: `${process.env.REACT_APP_API_URL}/api`,
//   withCredentials: true, // 🔐 завжди надсилаємо куки
// });

// // 🔥 Перехоплювач для додавання токена з localStorage, якщо він є
// axiosInstance.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// export default axiosInstance;

import axios from "axios";
import CryptoJS from "crypto-js";

// === Конфігурація axios ===
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  withCredentials: true, // 🔐 для cookie, auth тощо
});

// === AES ключ ===
const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY || "fallback-key-123";

// === Функція шифрування ===
function encryptData(data) {
  try {
    const ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      SECRET_KEY
    ).toString();
    return ciphertext;
  } catch (err) {
    console.error("❌ Encryption error:", err);
    return null;
  }
}

// === Перехоплення запитів ===
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const hostname = window.location.hostname;
  const isProd = hostname === "myzooshop.com.ua" || hostname === "www.myzooshop.com.ua";

  // 🔒 Шифруємо POST/PUT запити лише у продакшн
  if (isProd && ["post", "put"].includes(config.method)) {
    if (config.data && typeof config.data === "object") {
      config.data = { payload: encryptData(config.data) };
    }
  }

  return config;
});

export default axiosInstance;
